const DATE_FORMAT_DB = "YYYY-MM-DD";
const DATE_FORMAT_FOR_DATE_OBJ = "MM-DD-YYYY";
const DATE_FORMAT_SLASH = "MM/DD/YYYY";
const DATE_TIME_FORMAT = "MMM DD, YYYY @ hh:mm A";
const DATE_FORMAT_SHORT_MONTH = "MMM DD, YYYY";
const DATE_FORMAT_FULL_MONTH = "MMMM DD, YYYY";
const DATE_TIME_FULL = "YYYY-MM-DD HH:mm:ss";

const formats = {
  DATE_FORMAT_DB,
  DATE_FORMAT_FOR_DATE_OBJ,
  DATE_FORMAT_SLASH,
  DATE_TIME_FORMAT,
  DATE_FORMAT_SHORT_MONTH,
  DATE_FORMAT_FULL_MONTH,
  DATE_TIME_FULL
};

export const dateUtilityMixin = {
  methods: {
    // note, check date type, might need to use unixDateTime (below)
    date(date, format = "DATE_FORMAT_DB") {
      const momentDate =
        typeof date === "string" && date.includes(":")
          ? this.moment.utc(date).local() // for 0000-00-00 00:00:00
          : this.moment(date); // for YYYY-MM-DD, date objects, etc.
      const dateFormat = formats[format];
      return {
        dateObject: momentDate._d,
        formatted: momentDate.format(dateFormat),
        isValid: momentDate.isValid()
      };
    },

    formatDateForRequest(date) {
      if (this.date(date).isValid) {
        return this.date(date).formatted;
      }

      return "";
    },

    datesMatch(dateOne, dateTwo) {
      let match = null;

      if (this.moment(dateOne).isValid() && this.moment(dateTwo).isValid()) {
        match = dateOne.toString() === dateTwo.toString();
      }

      return match;
    },

    yesterday() {
      let momentDate = this.moment()
        .startOf("day")
        .subtract(1, "days");
      return {
        dateObject: momentDate._d,
        formatted: momentDate.format(DATE_FORMAT_DB)
      };
    },

    startOfToday(format = "DATE_FORMAT_DB") {
      let momentDate = this.moment().startOf("day");
      return {
        dateObject: momentDate._d,
        formatted: momentDate.format(formats[format])
      };
    },

    today(format = "DATE_FORMAT_DB") {
      let momentDate = this.moment();
      return {
        dateObject: momentDate._d,
        formatted: momentDate.format(formats[format])
      };
    },

    tomorrow() {
      let momentDate = this.moment().add(1, "days");
      return {
        dateObject: momentDate._d,
        formatted: momentDate.format(DATE_FORMAT_DB)
      };
    },

    dateAfter(numberOfDays, format = "DATE_FORMAT_DB") {
      let momentDate = this.moment()
        .startOf("day")
        .add(numberOfDays, "days");
      return {
        dateObject: momentDate._d,
        formatted: momentDate.format(formats[format])
      };
    },

    unixDateTime(date, format = "DATE_TIME_FORMAT") {
      const unixDate = this.moment.unix(date); // "Note: Despite Unix timestamps being UTC-based, this function creates a moment object in local mode." https://momentjs.com/docs/#/parsing/unix-timestamp/
      return {
        dateObject: unixDate._d,
        formatted: unixDate.format(formats[format])
      };
    },

    daysBetweenInclusive(startDate, endDate) {
      // note, moment.diff is exclusive
      const diff = this.moment(endDate).diff(this.moment(startDate), "days");

      return diff + 1;
    },

    enumerateDaysBetweenDates(startDate, endDate) {
      let now = startDate.clone();
      let dates = [];

      while (now.isSameOrBefore(endDate)) {
        dates.push(now.clone()._d);
        now.add(1, "days");
      }
      return dates;
    }
  }
};
